export default function parse_html(str) {
  var txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value ? txt.value : '';
}